<template>
  <nav class="navbar">
    <loading :isActive="loading" />
    <div class="navbar-brand">
      <a href="" class="navbar-logo">
        <img :src="logo" class="login__logo" alt="CMS" />
      </a>
    </div>
    <div class="navbar-menu">
      <a href="" class="navbar-logout" v-on:click="logout">
        <span>Logout</span>
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <path d="M360.233,121.189c11.046,0,20-8.954,20-20V49.378C380.233,22.151,357.837,0,330.31,0H90.923C63.396,0,41,22.151,41,49.378 v413.244C41,489.849,63.396,512,90.923,512H330.31c27.527,0,49.923-22.151,49.923-49.378v-51.811c0-11.045-8.955-19.999-20-19.999 c-11.046,0-20,8.954-20,20v51.811c0,5.171-4.451,9.378-9.923,9.378H90.923c-5.472,0-9.923-4.207-9.923-9.378V49.378 C81,44.207,85.451,40,90.923,40H330.31c5.472,0,9.923,4.207,9.923,9.378v51.811C340.233,112.235,349.187,121.189,360.233,121.189z "/> </g> <g> <path d="M464.963,241.682L358.521,137.881c-7.908-7.713-20.571-7.554-28.281,0.355c-7.712,7.907-7.553,20.57,0.355,28.281 L401.845,236H210.616c-11.046,0-20,8.954-20,20s8.954,20,20,20h191.229l-71.25,69.482c-7.908,7.711-8.067,20.374-0.355,28.281 c7.709,7.907,20.373,8.07,28.281,0.355l106.442-103.801C473.061,262.436,472.963,249.469,464.963,241.682z"/> </g> </svg>
      </a>
    </div>
  </nav>
</template>
<script>
import { get } from '@/helpers/apiRequest'
import { getImage } from '@/helpers/utils'

const url = '/configuracao'

export default {
  name: 'navbar',
  data () {
    return {
      logo: null,
      loading: false
    }
  },
  methods: {
    logout () {
      this.loading = true
      localStorage.clear()
      this.loading = false
      this.$router.push('/login')
    }
  },
  beforeMount () {
    if(localStorage.getItem('token')){
      get(url)
        .then(json => {
          this.logo = getImage(json.currentImg)
        })
      }else{
        this.$router.push('/login')
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/NavBar.vue